import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=407a94e2&"
import script from "./MessageDetail.vue?vue&type=script&lang=ts&"
export * from "./MessageDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports